import messages from './notificationMessages.js';
import { getWalletNotificationData } from '../../utilities/notifications/getWalletNotificationData.js';
const getNotificationData = (hasNewTradeIn, dealNotifications, dealDetails) => getWalletNotificationData(hasNewTradeIn, dealNotifications, dealDetails, messages);
export { getNotificationData as default };
